<script setup lang="ts">
import { computed, defineModel } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import Stepper from 'primevue/stepper';
import StepItem from 'primevue/stepitem';
import Step from 'primevue/step';
import StepPanel from 'primevue/steppanel';

import CalculationViewLink from '@/components/CalculationViewLink.vue';
import { useSelectViewItems } from '@/composables/useSelectViewItems';
import CalculationViewForm from '../components/CalculationViewForm.vue';
import { useHiddenInputs } from '../composables/useHiddenInputs';

import { useCurrentSegment } from '../composables/useCurrentSegment';

const selectedItems = defineModel<{ [key: string]: number | null }>('selectedItems', {
  type: Object,
  required: true,
});

const route = useRoute();
const router = useRouter();

const { isHiddenInputs } = useHiddenInputs();

const { currentSegmentGroupsViews, currentSegment } = useCurrentSegment();

const currentStepperValue = computed(() => {
  return (
    Number(
      currentSegmentGroupsViews.value?.views?.findIndex(
        (view) => view.id === Number(route.params.viewId)
      )
    ) + 1
  );
});

const handleStepperUpdate = (event: number) => {
  router.push({
    name: 'CalculationViewItems',
    params: {
      ...route.params,
      viewId: currentSegmentGroupsViews.value?.views[event - 1]?.id || null,
    },
  });
};
const { viewLinks } = useSelectViewItems(selectedItems);

const mergedLinks = computed(() => {
  const segmentLinks = (currentSegment.value?.links as any[]) || [];
  const selectedViewLinks = (viewLinks as any)?.value ?? (viewLinks as any) ?? [];
  return [...segmentLinks, ...selectedViewLinks];
});

</script>

<template>
  <Stepper
    v-auto-animate
    v-if="currentSegmentGroupsViews"
    :value="currentStepperValue"
    @update:value="handleStepperUpdate"
  >
    <CalculationViewLink v-if="mergedLinks.length > 0" :links="mergedLinks" />
    <StepItem
      :value="index + 1"
      :key="view.id"
      v-for="(view, index) in currentSegmentGroupsViews?.views.filter(
        (view) => view.items.some((item) => !item.is_hidden) || !isHiddenInputs
      )"
    >
      <Step>
        <span class="max-w-11 text-wrap">
          {{ view.name }}
        </span>
      </Step>
      <StepPanel>
        <CalculationViewForm v-model:selected-items="selectedItems" />
      </StepPanel>
    </StepItem>
  </Stepper>
</template>
